import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';

export interface DeleteDocumentGroupingParams {
  id: string;
}

const deleteDocumentGrouping: MutationFunction<
  void,
  DeleteDocumentGroupingParams
> = async (args) => {
  if (isMockServices()) return await mock(undefined);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  await authTokenHttp(`/document-groupings/${args.id}`, {
    method: 'DELETE',
  });
};

export default deleteDocumentGrouping;
